import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents';

export interface IProcessStepProps {
  title: string;
  description: string;
  width?: number;
}

export const ProcessStep = ({ title, description, width = 880 }: IProcessStepProps) => {
  return (
    <Box width={width} gap={16}>
      <Typography as="span" size="heading_4" bold color={colors.primary[500]}>
        {title}
      </Typography>
      <Typography as="span" size="body_large">{description}</Typography>
    </Box>
  );
};
